import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ReactComponent as ReactLogo } from "../../assets/images/logo.svg";

export default function LoadingPage() {
  const navigate = useNavigate();

  return (
    <Box
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box width={"90%"} display={"flex"} justifyContent={"center"}>
        <Box
          sx={{
            width: "150px",
            height: "150px",
            "& path": {
              transformOrigin: "50% 50%",
              animationName: "load-spin",
              animationDuration: "800ms",
              animationIterationCount: "infinite",
              animationTimingFunction: "linear",
            },
          }}
        >
          <ReactLogo style={{ width: "100%", height: "100%" }} />
        </Box>
      </Box>
    </Box>
  );
}
